import React, {Component} from 'react';
import {Link} from 'react-router-dom';

import logo from '../assets/images/logo_2x.png';

export function Footer1(){
    return(
        <div id="footer">
            <div className="nav_footer">
                <div className="container">
                    <ul>
                        <li className="column_footer">
                            <h5>Resources</h5>
                            <Link to="/pricing">Pricing</Link>
                            <Link to="/guide">Guide 101</Link>
                            <Link to="#">Blog</Link>
                            <Link to="/pricing">FAQ</Link>
                        </li>
                        <li className="column_footer">
                            <h5>Company</h5>
                            <Link to="/about-us">About</Link>
                            <Link to="/contact">Contact</Link>
                            <a href="https://www.facebook.com/sosiago.id/" target="_blank">Facebook</a>
                            <a href="https://www.instagram.com/sosiago/" target="_blank">Instagram</a>
                            <a href="https://twitter.com/sosiagoid" target="_blank">Twitter</a>
                        </li>
                        <li className="column_footer">
                            <h5>Legal</h5>
                            <Link to="/terms-and-conditions">Terms</Link>
                            <a href="https://www.linkedin.com/company/sosiago" target="_blank">LinkedIn</a>                                      
                        </li>
                    </ul>
                    <a href="/" className="logo">
                        <img src={logo} alt="logo" height="42px"/>
                    </a>                    
                </div>
                <div className="container reserved">
                    <h5>SosiaGo Indonesia. All rights reserved 2018.</h5>
                </div>
            </div>
        </div>   
    )             
}


// WEBPACK FOOTER //
// ./src/components/Footer.js